var _path, _ellipse, _ellipse2, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhotoShareWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8564 1.45654H11.041C11.763 1.45661 12.4077 1.75935 13.0742 2.23193C13.4076 2.46834 13.7342 2.73859 14.0752 3.02393C14.3272 3.23486 14.5886 3.45518 14.8564 3.6665L15.127 3.87451C15.3888 4.06989 15.7113 4.21631 16.084 4.21631H16.9971C19.4113 4.21635 21.381 6.11731 21.4932 8.50146L21.498 8.73389L21.4668 17.061C21.4573 19.5395 19.4453 21.5435 16.9668 21.5435H5C2.51472 21.5435 0.5 19.5287 0.5 17.0435V8.97217C0.500034 6.50487 2.51865 4.5706 5.05078 4.24268L5.29785 4.21631C5.72414 4.1792 6.14346 4.12202 6.44434 4.01709L6.56543 3.96924C7.4432 3.57475 8.20706 2.8667 8.8584 2.35791C9.55024 1.81749 10.1553 1.45669 10.8564 1.45654Z",
    fill: "#333333",
    stroke: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.0022,
    cy: 13.0064,
    rx: 2.2004,
    ry: 2.25934,
    stroke: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.0019,
    cy: 13.0065,
    rx: 4.4008,
    ry: 4.51868,
    stroke: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.66732,
    cy: 7.37435,
    r: 0.916834,
    stroke: "white",
    strokeWidth: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoShareWhite);
export default __webpack_public_path__ + "static/media/photo-share-white.7ca2e7df0dc04b6d29375b577f3cfc6d.svg";
export { ForwardRef as ReactComponent };